import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import {
  FreeVodConfigEntity,
  OptionGroupsConfigEntity,
  OptionsCategoriesConfigEntity,
  SettingsCategoriesConfigEntity, SettingsCtaFilterConfigEntity,
} from '../configs/entity.config';
import { CustomerService } from '@proximus/ng-common';

@Injectable({
  providedIn: 'root',
})
export class MagnoliaConfigService {
  constructor(private customerService: CustomerService) {}

  getOptionGroups(): Observable<IEntity<any>> {
    return EntityManager.getEntity(OptionGroupsConfigEntity, {
      segment: this.getCustomerSegment(),
    });
  }

  getOptionsCategories(): Observable<IEntity<any>> {
    return EntityManager.getEntity(OptionsCategoriesConfigEntity, {
      segment: this.getCustomerSegment(),
    });
  }

  getSettingsCategories(): Observable<IEntity<any>> {
    return EntityManager.getEntity(SettingsCategoriesConfigEntity, {
      segment: this.getCustomerSegment(),
    });
  }

  getFreeVod(): Observable<IEntity<any>> {
    return EntityManager.getEntity(FreeVodConfigEntity, {
      segment: this.getCustomerSegment(),
    });
  }

  getSettingsCtaFilter(): Observable<IEntity<any>> {
    return EntityManager.getEntity(SettingsCtaFilterConfigEntity, {
      segment: this.getCustomerSegment(),
    });
  }

  private getCustomerSegment() {
    let segment = 'res';
    this.customerService.getCustomerAccount().subscribe((value) => {
      switch (value.getSelectedCustomer().subsegment) {
        case 'RES':
        case 'PRE':
          segment = 'res';
          break;
        case 'BUS':
          segment = 'se';
          break;
        case 'COR':
          segment = 'cor';
          break;
      }
      return segment;
    });
    return segment;
  }
}
